/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { getShop } from 'src/helpers';

type State = {
  dismissedBanner: boolean
};

class DidYouKnow extends Component<WithI18nProps, State> {
  state = {
    dismissedBanner: false
  };

  componentDidMount() {
    // Hide banner
    this.checkDismissedBanner();
  }

  render() {
    const { i18n } = this.props;
    const { dismissedBanner } = this.state;

    return !dismissedBanner ? (
      <Banner
        title={i18n.translate('AdminHTML.SwitchLayout.DidYouKnow.title')}
        status="info"
        onDismiss={this.onDismiss}>
        <TextStyle>{i18n.translate('AdminHTML.SwitchLayout.DidYouKnow.content')}</TextStyle>
      </Banner>
    ) : (
      ''
    );
  }

  // Get dismissed banner status
  checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(`${shop}-dismissSwitchLayoutBanner`);
    } catch (error) {}

    if (dismissed === 'true') {
      this.setState({ dismissedBanner: true });
    }
  };

  // Handle hide banner
  onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissSwitchLayoutBanner`, true);
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(DidYouKnow);
